<template>
  <div class="w98">
   <div class="crumb">
      <span><router-link to="/Help">帮助</router-link>  > </span>
      <span>典型病例库</span>
    </div>
     <help-Menu></help-Menu>
    <div class="rightContent">
      <div class="conten">
              <p class="text">此模块归属于“资料中心”，用户可以在此新增编辑自己的病例，并存放在公共分类中或者个人分类中。
                 公共分类中的病例可供科室内部医生查看，个人分类中的病例只可自己查看修改。</p>
       <el-collapse accordion>
          <el-collapse-item>
            <template slot="title">
              典型病例库
            </template>
            <h1 class="titleBar">分类列表</h1>
            <p class="text">分类列表处分为公共分类和个人分类tab页，支持列表的切换</p>
            <div>
              <p class="text">公共分类：支持模糊查询，用户可在查询框中输入关键字，点击<img  class="littleImg"  src="../../../../static/image/68.png"/>，列表返回对应的查询结果。
              公共分类共包括四个分类，分别为自定义分类、按诊断分类、按部位分类、按科室分类，分类不支持修改。
              </p>
              <img src="../../../../static/image/4.png"/>
              <p class="text">个人分类：同公共分类一致，支持模糊查询。个人分类支持自定义分类，可新增、删除个人分类。</p>
              <p class="text">1)新增：点击<img  class="littleImg"  src="../../../../static/image/69.png"/>按钮，在文本框中输入分类名称，点击“确定”按钮即可新增成功。</p>
              <p class="text">2)删除：选中一分类，点击“删除”按钮，即可删除此条个人分类。</p>
              <h1 class="titleBar">病例添加</h1>
              <p class="text">用户点击【添加病例】，进入病例新增页面。在病例新增时，用户需完成“基本信息”、“选择影像”、“上传附件”以及病例分类的填充选择（选择影像、上传附件不是必填项），最后点击【确定】，最终完成整个病例的新增。</p>
              <p class="text">“病例名称”、“性别”、“病例分类”为必填项，“年龄”、“备注”以及“就诊信息”为选填项。其中病例分类不可同时勾选公共分类和个人分类。</p>
              <p class="textlittle">1)病例分类选择<strong style="font-weight:bolder">公开分类</strong>下的分类：该病例为科室内公开可见。</p>
              <p class="textlittle">2)病例分类选择<strong style="font-weight:bolder">个人分类</strong>下的分类：该病例仅为个人所见。</p>
            </div>
          </el-collapse-item>
          <el-collapse-item title="关联影像">
             <h1 class="titleBar">影像添加</h1>
             <p class="text">用户点击右侧按钮【从本院影像选择】，弹出影像库（图-本院影像），在影像库中，勾选相关影像后，点击“确定”后，完成添加，如图-影像队列。</p>
            <div><img src="../../../../static/image/10.png"/></div>
            <p style="margin-left:30%">图-本院影像</p>
            <div><img src="../../../../static/image/11.png"/></div>
            <p style="margin-left:30%">图-影像队列</p>
            <h1 class="titleBar">影像删除</h1>
            <p>用户点击影像列表的<img  class="littleImg"  src="../../../../static/image/75.png"/>，即可从队列中删除该影像记录。</p>
            <h1 class="titleBar">影像阅片</h1>
            <P>用户点击影像列表的<img  class="littleImg"  src="../../../../static/image/71.png"/>，即可调用系统的阅片工具对该记录进行阅片。</P>
          </el-collapse-item>
          <el-collapse-item title="添加附件">
            <h1 class="titleBar">“文件类型”添加</h1>
            <P class="text">用户点击左侧按钮【从我的电脑选择】，弹出文件选择框，选择指定文件后，点击“确定”后，完成添加（只支持单个文件的添加，并且文件大小小于30M，最多添加10个）。</P>
            <h1 class="titleBar">“文件类型”删除</h1>
            <P class="text">用户点击文件图标右上角<img  class="littleImg"  src="../../../../static/image/72.png"/>，确认后，即可删除文件。</P>
            <h1 class="titleBar">“其他图片”添加</h1>
            <p class="text">用户点击左侧按钮【从我的电脑选择】，弹出文件选择框，选择指定文件后，点击“确定”后，完成添加（只支持单个文件的添加，并且文件大小小于3M，最多添加10个）。</p>
            <h1 class="titleBar">“其他图片”删除</h1>
            <P class="text">用户点击文件图标右上角<img  class="littleImg"  src="../../../../static/image/73.png"/>，确认后，即可删除文件。</P>
          </el-collapse-item>
        </el-collapse>
      </div>
    </div>
</div>
</template>

<script type="text/ecmascript-6">
  import {getRightHeight} from '@/common/js/rightHeight'
  import helpHead from '@/components/common/header/helpHead'
  import helpMenu from '@/components/common/helpMenu/helpMenu'
  export default {
    data () {
      return {
         height:''
      }
    },
    components:{
        helpHead,
        helpMenu
    },
      mounted() {
      setTimeout(() => {
//        this._getRightW()
        getRightHeight('rightContent', this.height)
      }, 20)
      window.addEventListener('resize', () => {
//        this._getRightW()
        getRightHeight('rightContent', this.height)
      })
    },
}

</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.content
    min-width: 100vw
    height: 100vh
    overflow: hidden
  .rightContent
    position: relative
    float: right
    height :calc(100vh - 80px)
    width: calc(80% - 1px)
    min-width: 919px
    background :#fff
    overflow:auto
  .conten
     padding: 25px 25px 25px 30px
  .titleBar
     color:#000
     font-size:14px
     font-weight:bolder
  .text
     color:#555
     line-height: 25px
     text-indent:2em
  .textlittle
    text-indent:4em
  img
   width:80%
  .littleImg
     width:30px
     vertical-align:middle
 .crumb
 line-height: 30px
 margin: 5px 0 0 20px

</style>




// WEBPACK FOOTER //
// TypicalBank.vue?edca6aec